import { Stack } from "@mui/material"
import { Context, ReactElement, useContext } from "react"
import { useForm } from "react-hook-form"

import {
    EVAC_MANUFACTURER_REG,
    evacDeviceFormLabelMapping,
} from "../../../../../constants/lct/evac/deviceForm"
import { useFilterReferenceMappings } from "../../../../../hooks/useFilterReferenceMappings"
import { GRID_SPACING } from "../../../../../themes/defaultThemeParams"
import FormErrors from "../../../../formErrors/formErrors"
import FormHeader from "../../../../formHeader/formHeader"
import FormNavigation from "../../../../formNavigation/formNavigation"
import ValidatedAutocomplete from "../../../../inputs/validated/validatedSelect"
import { AppCard } from "../../../../surfaces/appCard"
import { MANU_SUBTITLE } from "../../../common/labels"
import { IDeviceFormContextValue } from "../../../types/providerTypes"
import { EVACDeviceFormData } from "../../types/providerTypes"

const mapRegisterNameToValues = (
    formData: EVACDeviceFormData
): { [name: string]: NonNullable<unknown> | undefined | null } => ({
    [EVAC_MANUFACTURER_REG]: formData.manufacturerId,
})

interface IEVACManufacturerProps {
    context: Context<IDeviceFormContextValue<EVACDeviceFormData>>
}

const EVACManufacturer = ({
    context,
}: IEVACManufacturerProps): ReactElement => {
    const { currentIndex, setCurrentIndex, formData, setFormData } =
        useContext(context)

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: mapRegisterNameToValues(formData),
        values: mapRegisterNameToValues(formData),
        shouldUnregister: true,
    })

    const { manufacturerMappings, manufacturerIds, isLoading } =
        useFilterReferenceMappings()

    const updateManufacturer = (): void => {
        formData.manufacturerId = watch(EVAC_MANUFACTURER_REG) as string
        setFormData({ ...formData })
    }

    const onClickNext = (): void => {
        updateManufacturer()
        setCurrentIndex(currentIndex + 1)
    }

    return (
        <AppCard>
            <Stack spacing={GRID_SPACING * 2}>
                <FormHeader
                    header="Manufacturer"
                    subHeader={MANU_SUBTITLE}
                    index={currentIndex + 1}
                />
                <ValidatedAutocomplete
                    control={control}
                    required
                    registerName={EVAC_MANUFACTURER_REG}
                    label={evacDeviceFormLabelMapping[EVAC_MANUFACTURER_REG]}
                    options={manufacturerIds}
                    getOptionLabel={(option) => manufacturerMappings[option]}
                    loading={isLoading}
                />
                <FormErrors
                    errors={errors}
                    getFriendlyName={(key: string) =>
                        evacDeviceFormLabelMapping[key]
                    }
                />
                <FormNavigation
                    onClickNext={() => handleSubmit(onClickNext)()}
                    nextText="Next"
                    nextDisabled={isLoading}
                />
            </Stack>
        </AppCard>
    )
}

export default EVACManufacturer
